import React, { useEffect } from "react";
import { useLocation, useNavigate, Navigate, Outlet } from "react-router-dom";
import useToken from "../common/helper/usetoken";
import { useSelector } from "react-redux";
import { message } from 'antd';
import testjson from "./permissionTestJSON.json";
import { persistor } from "../reudx-toolkit/store";
import { useWebSocket } from "../context/WebSocketContext";

const PrivateRoutes = () => {
  //   const main_menu = testjson?.menus;
  const main_menu = useSelector((state) => state.menu.items);
  const { userID, setUserId, removeToken, decodedUserToken } = useToken();
  const { webSocketService, setSelectedUserID } = useWebSocket();
  const location = useLocation();
  const navigate = useNavigate();
  const currentRoute = location.pathname;

  // console.log("main menu from server/store==========" , main_menu); 

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (main_menu?.length == 0) {
  //       message.error("You don't have permission to access this application. Please contact your administrator.");
  //       removeToken();
  //       setUserId(null);
  //       setSelectedUserID(null);
  //     webSocketService.disconnect();
  //   }
  // }, 500);
  // }, []);

  let token = localStorage.getItem("@token");
  if (!token) {
    return <Navigate to="/login" />;
  } else if (currentRoute === "/confirmation") {
    return <Outlet />;
  }
  else {
    if (main_menu?.length > 0) {
      let check = main_menu.findIndex(x => x.route === "airport-list")
      if (check > -1 && (currentRoute.includes("/airport/") || currentRoute.includes("/airline-detail/") || currentRoute.includes("/contact/"))) {
        return <Outlet />;
      }

      check = main_menu.findIndex(x => x.route === "shipment")
      if (check > -1 && (currentRoute.includes("/shipment/external-view/"))) {
        return <Outlet />;
      }

      if (currentRoute === "/onboarding") {
        let isOnboarded = false;
        let decodedToken = decodedUserToken();
        // let role = decodedToken?.role?.toLowerCase() === "admin";
        let role = decodedToken?.role?.toLowerCase() === "admin";
        if (decodedToken) {
          isOnboarded = decodedToken?.is_onboarded === true;
        }
        if (role === true) {
          return <Outlet />;
        } else {
          const firstRoute = main_menu.find(item => item.route && typeof item.route === "string");
          if (firstRoute) {
            navigate(`/${firstRoute.route}`);
          }
        }
      }

 
      // onboarding can access only one time for admin or any other member

      // if (currentRoute === "/onboarding") {
      //   const decodedToken = decodedUserToken();
      //   const isOnboarded = decodedToken?.is_onboarded === true;
      
      //   if (isOnboarded) {
      //     const firstRoute = main_menu.find(item => item.route && typeof item.route === "string");
      //     if (firstRoute) {
      //       navigate(`/${firstRoute.route}`);
      //       return null;
      //     }
      //   }
      
      //   return <Outlet />;
      // }
      


      const hasPermission = (menuItems, route) => {
        // if (route === '/dashboard') return true;
        for (let item of menuItems) {
          if (`/${item.route}` === route) {
            return item.permissions.is_view;
          }
          const subMenuItem = item.sub_menus.find((subMenu) => {
            if (`${subMenu.route}` === route) {
              return subMenu; // This is important: `find` needs a return value
            }
            return null; // Ensure you return false if not matched
          });

          // const subMenuItem = item.sub_menus.find(
          //   (subMenu) => {
          //
          //     if(`${subMenu.route}` === route){

          //     }
          //     `${subMenu.route}` === route}
          // );
          if (subMenuItem) {
            return subMenuItem.permissions.is_view;
          }
        }
        return false;
      };

      const permissionGranted = hasPermission(main_menu, currentRoute);
      if (!permissionGranted) {
        return window.history.back();
      }
      return <Outlet />;
    }
    // else {
    //   message.error("Something went wrong!")
    // }
  }
};

export default PrivateRoutes;
